export default "__VITE_ASSET__2dedaf85__"